import { render, staticRenderFns } from "./ImpedimentContainer.vue?vue&type=template&id=673de33c&scoped=true"
import script from "./ImpedimentContainer.vue?vue&type=script&lang=js"
export * from "./ImpedimentContainer.vue?vue&type=script&lang=js"
import style0 from "./ImpedimentContainer.vue?vue&type=style&index=0&id=673de33c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "673de33c",
  null
  
)

export default component.exports